<div class="practice-table" *ngIf="isTranslationLoaded">
  <h3>{{ "reportingV2.PRACTICE_ASSIGNMENT_LABEL" | transloco }}</h3>
  <div class="table-wrapper">
    <div *ngIf="isLoading" class="loading-container">
      <qai-loading [size]="'medium'"></qai-loading>
    </div>

    <qai-table
      *ngIf="!isLoading && tableData.length > 0"
      [headers]="headers"
      [data]="tableData"
      [currentPage]="currentPage"
      [initialSortColumn]="initialSortColumn"
      [initialSortDirection]="initialSortDirection"
      (rowClick)="onTableRowClick($event)"
      (cellClick)="onCellClick($event)"
      (pageChanged)="onPageChanged($event)"
      (sortChanged)="onSortChanged($event)"
      [previousLabel]="'reportingV2.PAGINATION_PREVIOUS' | transloco"
      [nextLabel]="'reportingV2.PAGINATION_NEXT' | transloco"
    ></qai-table>
  </div>
</div>
